module.exports = {
	proxyUrl: 'class-vrnew.test',
	port: 3000,
};

